import { Box, Container, Divider, Link, Typography } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import type React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#f8f9fa',
        mt: 'auto',
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        {/* Follow us on section with divider */}
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', mb: 3 }}>
          <Divider sx={{ flex: 1 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 3 }}>
            <Typography variant="body1" sx={{ color: '#666', whiteSpace: 'nowrap' }}>
              Follow us on
            </Typography>
            <Link
              href="https://au.linkedin.com/company/allianz-retireplus"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#003781', display: 'flex', '&:hover': { opacity: 0.7 } }}
              aria-label="LinkedIn"
            >
              <LinkedInIcon sx={{ fontSize: 40 }} />
            </Link>
            <Link
              href="https://www.youtube.com/channel/UCuSCFbUfsQdjNgLfG7lK5qQ?view_as=subscriber"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#003781', display: 'flex', '&:hover': { opacity: 0.7 } }}
              aria-label="YouTube"
            >
              <YouTubeIcon sx={{ fontSize: 40 }} />
            </Link>
          </Box>
          <Divider sx={{ flex: 1 }} />
        </Box>

        {/* Disclaimer text */}
        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
            Any information on this website does not take into account your objectives, financial situation or needs. For personal financial advice please speak to your financial adviser. Products will be issued by Allianz Australia Life Insurance Limited, ABN 27 076 033 782, AFSL 296559.
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Allianz Retire+ is the business name of Allianz Australia Life Insurance Limited. By using this website you agree to access this{' '}
            <Link
              href="https://www.allianzretireplus.com.au/financial-services-guide.html"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#003781', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              Financial Services Guide
            </Link>.
          </Typography>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Footer links */}
        <Box
          component="nav"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: { xs: 2, sm: 3 },
            mb: 2,
          }}
        >
          <Typography variant="body2" component="small" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
            Copyright © {currentYear} Allianz Australia Life Insurance Limited
          </Typography>
          <Link
            href="https://www.allianzretireplus.com.au/terms-of-use.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#003781', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { textDecoration: 'underline' } }}
          >
            Term of Use
          </Link>
          <Link
            href="https://www.allianzretireplus.com.au/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#003781', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { textDecoration: 'underline' } }}
          >
            Privacy
          </Link>
          <Link
            href="https://www.allianzretireplus.com.au/security.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#003781', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { textDecoration: 'underline' } }}
          >
            Security
          </Link>
          <Link
            href="https://www.allianzretireplus.com.au/complaints-policy.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#003781', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { textDecoration: 'underline' } }}
          >
            Complaints
          </Link>
          <Link
            href="https://www.allianzretireplus.com.au/whistleblower-policy.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#003781', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { textDecoration: 'underline' } }}
          >
            Whistleblower
          </Link>
        </Box>


      </Container>
    </Box>
  );
};

export default Footer;
